import React from "react"

import Radio from "../../atoms/Radio"
import styles from "./index.module.scss"

export default function Radios(props) {
  const { radios, onChange } = props

  if (!radios?.length) return null
  return (
    <div className={styles.radiosContainer}>
      {radios.map((radio, index) => (
        <Radio
          key={index}
          {...radio}
          id={radio.value}
          onClick={(e) => onChange(e.target.value)}
        />
      ))}
    </div>
  )
}
